import { render, staticRenderFns } from "./LmUsersGroups.vue?vue&type=template&id=067c2564"
import script from "./LmUsersGroups.vue?vue&type=script&lang=js"
export * from "./LmUsersGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports